import DecisionQuestionsEditor from "./decision_questions_editor";

const ActionArg = {
  Component: DecisionQuestionsEditor,
  default: {value: []},
};

export default ActionArg;
